import React from 'react';
import storeManager from '../../store/StoreManager';
import {changeContextMode, refreshShapePosition, updateCurrentSlideContent} from '../../actions/MenuActions';
import modeType from '../../constants/ModeConstants';
import { addAnimation, selectShape, animate, removeAnimation, changeInteractionState } from '../../actions/CurrentSlideActions';
import shapeTypes from '../../constants/ShapeConstants';
import uuid from 'uuid';
import { updateCurrentSlide } from '../../actions/ProductionActions';
import previewCommands from './PreviewCommands';
import playController from './PlayController';
import textSizeUtils from './TextSizeUtils';
import platformDetection from './PlatformDetection';
import saveManager from './SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import {uiProperties} from './TransformToolUtils';
import appParameters from './AppParameters';
import mouseUtils from "./MouseUtils";

const animationManager = {
    allowAnimation: true,
    target: undefined,
    clone: undefined,
    clonesArray: [],
    isAnimationEditor: false,
    rotationType: 1,

    getDispatch() {
        const store = storeManager.getStore();
        return store.dispatch;
    },
    isAnimationMode() {
       return this.isAnimationEditor;
    },
    updateGroupShapesSize (shapeGroup, oldWidth, newWidth, oldHeight, newHeight) {
        var i;
        var shape;
        var shapes = shapeGroup.shapes;
        var newGroupedShapes = [];
        var widthScale = newWidth / oldWidth;
        var heightScale = newHeight / oldHeight;

        for (i=0; i<shapes.length; i++) {
            shape = Object.assign({}, shapes[i]);

            switch (shape.type) {
                case shapeTypes.LINE: {
                    shape.x1 = shape.x1 * widthScale;
                    shape.y1 = shape.y1 * heightScale;
                    shape.x2 = shape.x2 * widthScale;
                    shape.y2 = shape.y2 * heightScale;
                    break;
                }

                case shapeTypes.CURVE: {
                    shape.x1 = shape.x1 * widthScale;
                    shape.y1 = shape.y1 * heightScale;
                    shape.x2 = shape.x2 * widthScale;
                    shape.y2 = shape.y2 * heightScale;
                    shape.cx = shape.cx * widthScale;
                    shape.cy = shape.cy * heightScale;
                    break;
                }

                default: {
                    var oldW = shape.width;
                    var oldH = shape.height;

                    shape.x = shape.x * widthScale;
                    shape.y = shape.y * heightScale;
                    shape.width = shape.width * widthScale;
                    shape.height = shape.height * heightScale;

                    if (shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE) {
                        shape.cx = shape.cx * widthScale;
                        shape.cy = shape.cy * heightScale;
                        shape.path = undefined;

                        if (shape.cx1 && shape.cy1) {
                            shape.cx1 = shape.cx1 * widthScale;
                            shape.cy1 = shape.cy1 * heightScale;
                        }

                        if (shape.cx2 && shape.cy2) {
                            shape.cx2 = shape.cx2 * widthScale;
                            shape.cy2 = shape.cy2 * heightScale;
                        }

                        if (shape.cx3 && shape.cy3) {
                            shape.cx3 = shape.cx3 * widthScale;
                            shape.cy3 = shape.cy3 * heightScale;
                        }

                        if (shape.cx4 && shape.cy4) {
                            shape.cx4 = shape.cx4 * widthScale;
                            shape.cy4 = shape.cy4 * heightScale;
                        }

                        if (shape.cx5 && shape.cy5) {
                            shape.cx5 = shape.cx5 * widthScale;
                            shape.cy5 = shape.cy5 * heightScale;
                        }
                    }

                    if (shape.type == shapeTypes.FREEHAND) {
                        var points = shape.pathPoints;
                        var j;

                        for (j=0; j<points.length; j++) {
                            points[j].x = points[j].x * widthScale;
                            points[j].y = points[j].y * heightScale;
                        }
                    }

                    if (shape.type == shapeTypes.GROUP)
                        this.updateGroupShapesSize(shape, oldW, shape.width, oldH, shape.height);

                    break;
                }
            }

            newGroupedShapes.push(shape);
        }

        shapeGroup.shapes = newGroupedShapes;
    },
    duplicateShape (model, animationStart, animation, isSelected = false) {
        const cloneShape = Object.assign({}, model);

        cloneShape.uuid = uuid.v4();
        cloneShape.isSelected = isSelected;

        if (model.type == shapeTypes.LINE || model.type == shapeTypes.CURVE) {
            if (animation) {
                cloneShape.x1 = animation.x1;
                cloneShape.y1 = animation.y1;
                cloneShape.x2 = animation.x2;
                cloneShape.y2 = animation.y2;
            } else {
                cloneShape.x1 = cloneShape.x1 + 10;
                cloneShape.y1 = cloneShape.y1 + 10;
                cloneShape.x2 = cloneShape.x2 + 10;
                cloneShape.y2 = cloneShape.y2 + 10;
            }

            if (model.type == shapeTypes.CURVE) {
                if (animation) {
                    cloneShape.cx = animation.cx;
                    cloneShape.cy = animation.cy;
                } else {
                    cloneShape.cx = cloneShape.cx + 10;
                    cloneShape.cy = cloneShape.cy + 10;
                }
            }
        } else {
            if (animation) {
                cloneShape.x = animation.x;
                cloneShape.y = animation.y;
                cloneShape.width = animation.width;
                cloneShape.height = animation.height;

                if (model.type == shapeTypes.SPEAK_BUBBLE || model.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || model.type == shapeTypes.SCREAM_BUBBLE || model.type == shapeTypes.THOUGHT_BUBBLE) {
                    cloneShape.cx = animation.cx;
                    cloneShape.cy = animation.cy;

                    if (cloneShape.cx1) {
                        cloneShape.cx1 = animation.cx1;
                        cloneShape.cy1 = animation.cy1;
                    }

                    if (cloneShape.cx2) {
                        cloneShape.cx2 = animation.cx2;
                        cloneShape.cy2 = animation.cy2;
                    }

                    if (cloneShape.cx3) {
                        cloneShape.cx3 = animation.cx3;
                        cloneShape.cy3 = animation.cy3;
                    }

                    if (cloneShape.cx4) {
                        cloneShape.cx4 = animation.cx4;
                        cloneShape.cy4 = animation.cy4;
                    }

                    if (cloneShape.cx5) {
                        cloneShape.cx5 = animation.cx5;
                        cloneShape.cy5 = animation.cy5;
                    }
                }

                if (model.type == shapeTypes.SPEAK_BUBBLE || model.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || model.type == shapeTypes.SCREAM_BUBBLE || model.type == shapeTypes.THOUGHT_BUBBLE || model.type == shapeTypes.TEXTBOX || model.type == shapeTypes.TEXTBOXSIMPLE)
                    cloneShape.fontSize = textSizeUtils.getFontSize(cloneShape, cloneShape.width, cloneShape.height, animationStart.width, animationStart.height);
            } else {
                var gap = 20;
                var newX = 0;
                var freeLeftSide = cloneShape.x;
                var freeRightSide = 800 - (cloneShape.x + cloneShape.width);

                if (freeRightSide >= (cloneShape.width + gap) || freeRightSide >= freeLeftSide || Math.abs(freeRightSide - freeLeftSide) < 3) { // should be added to the right side
                    newX = (cloneShape.x + cloneShape.width) + gap;

                    if ((newX + cloneShape.width) > 800)
                        newX = 800 - cloneShape.width;
                } else { // should be added to the left side
                    newX = cloneShape.x - cloneShape.width - gap;

                    if (newX < 0)
                        newX = 0;
                }

                if (model.type == shapeTypes.SPEAK_BUBBLE || model.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || model.type == shapeTypes.SCREAM_BUBBLE || model.type == shapeTypes.THOUGHT_BUBBLE) {
                    cloneShape.cx = cloneShape.cx + (newX - cloneShape.x);

                    if (cloneShape.cx1)
                        cloneShape.cx1 = cloneShape.cx1 + (newX - cloneShape.x);

                    if (cloneShape.cx2)
                        cloneShape.cx2 = cloneShape.cx2 + (newX - cloneShape.x);

                    if (cloneShape.cx3)
                        cloneShape.cx3 = cloneShape.cx3 + (newX - cloneShape.x);

                    if (cloneShape.cx4)
                        cloneShape.cx4 = cloneShape.cx4 + (newX - cloneShape.x);

                    if (cloneShape.cx5)
                        cloneShape.cx5 = cloneShape.cx5 + (newX - cloneShape.x);
                }

                cloneShape.x = newX;
            }

            if (cloneShape.type === shapeTypes.GROUP) {
                if (animationStart)
                    this.updateGroupShapesSize(cloneShape, animationStart.width, cloneShape.width, animationStart.height, cloneShape.height);
                else
                    this.updateGroupShapesSize(cloneShape, model.width, cloneShape.width, model.height, cloneShape.height);
            }
        }

        if (animation) {
            cloneShape.opacity = animation.opacity;
            cloneShape.rotation = animation.rotation;
        }

        return cloneShape;
    },
    deleteAnimation() {
        const dispatch = this.getDispatch();

        if (this.target) {
            dispatch(removeAnimation(this.target.uuid));
            saveManager.isContentChanged(true);
            audioEditorUtils.addActionToHistory();
        }

        this.exitAnimationMode();
    },
    addAnimation(isAnimationMode = false) {
        if (!this.target)
            return;

        let clone = this.clone;

        if (!clone)
            clone = this.cloneObject;

        if (!this.clonesArray || this.clonesArray.length == 0)
            this.clonesArray = this.cloneObjectsArray;

        if (!clone)
            return;

        const dispatch = this.getDispatch();
        let animation = {};
        let i;
        let points = [];

        if (this.clonesArray.length > 0) {
            for (i=0; i<this.clonesArray.length; i++) {
                let point = {};
                let currentElement = this.clonesArray[i];

                if (!(currentElement.opacity >= 0))
                    point.opacity = 1;
                else
                    point.opacity = currentElement.opacity;

                point.rotation = currentElement.rotation;

                points.push(point);
            }
        }

        if (this.target.type == shapeTypes.LINE || this.target.type == shapeTypes.CURVE) {
            animation.start_x1 = this.target.x1;
            animation.start_y1 = this.target.y1;
            animation.start_x2 = this.target.x2;
            animation.start_y2 = this.target.y2;

            animation.end_x1 = clone.x1;
            animation.end_y1 = clone.y1;
            animation.end_x2 = clone.x2;
            animation.end_y2 = clone.y2;

            if (this.target.type == shapeTypes.CURVE) {
                animation.start_cx = this.target.cx;
                animation.start_cy = this.target.cy;

                animation.end_cx = clone.cx;
                animation.end_cy = clone.cy;
            }

            for (i=0; i<this.clonesArray.length; i++) {
                points[i].x1 = this.clonesArray[i].x1;
                points[i].y1 = this.clonesArray[i].y1;
                points[i].x2 = this.clonesArray[i].x2;
                points[i].y2 = this.clonesArray[i].y2;

                if (this.target.type == shapeTypes.CURVE) {
                    points[i].cx = this.clonesArray[i].cx;
                    points[i].cy = this.clonesArray[i].cy;
                }
            }
        } else {
            animation.start_x = this.target.x;
            animation.start_y = this.target.y;
            animation.start_width = this.target.width;
            animation.start_height = this.target.height;

            animation.end_x = clone.x;
            animation.end_y = clone.y;
            animation.end_width = clone.width;
            animation.end_height = clone.height;

            if (this.target.type == shapeTypes.SPEAK_BUBBLE || this.target.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || this.target.type == shapeTypes.SCREAM_BUBBLE || this.target.type == shapeTypes.THOUGHT_BUBBLE) {
                animation.start_cx = this.target.cx;
                animation.start_cy = this.target.cy;
                animation.end_cx = clone.cx;
                animation.end_cy = clone.cy;

                if (this.target.cx1) {
                    animation.start_cx1 = this.target.cx1;
                    animation.start_cy1 = this.target.cy1;
                    animation.end_cx1 = clone.cx1;
                    animation.end_cy1 = clone.cy1;
                }

                if (this.target.cx2) {
                    animation.start_cx2 = this.target.cx2;
                    animation.start_cy2 = this.target.cy2;
                    animation.end_cx2 = clone.cx2;
                    animation.end_cy2 = clone.cy2;
                }

                if (this.target.cx3) {
                    animation.start_cx3 = this.target.cx3;
                    animation.start_cy3 = this.target.cy3;
                    animation.end_cx3 = clone.cx3;
                    animation.end_cy3 = clone.cy3;
                }

                if (this.target.cx4) {
                    animation.start_cx4 = this.target.cx4;
                    animation.start_cy4 = this.target.cy4;
                    animation.end_cx4 = clone.cx4;
                    animation.end_cy4 = clone.cy4;
                }

                if (this.target.cx5) {
                    animation.start_cx5 = this.target.cx5;
                    animation.start_cy5 = this.target.cy5;
                    animation.end_cx5 = clone.cx5;
                    animation.end_cy5 = clone.cy5;
                }
            }

            if (this.target.type == shapeTypes.SPEAK_BUBBLE || this.target.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || this.target.type == shapeTypes.SCREAM_BUBBLE || this.target.type == shapeTypes.THOUGHT_BUBBLE  || this.target.type == shapeTypes.TEXTBOX || this.target.type == shapeTypes.TEXTBOXSIMPLE) {
                animation.start_fontSize = this.target.fontSize;
                animation.end_fontSize = clone.fontSize;
            }

            for (i=0; i<this.clonesArray.length; i++) {
                points[i].x = this.clonesArray[i].x;
                points[i].y = this.clonesArray[i].y;
                points[i].width = this.clonesArray[i].width;
                points[i].height = this.clonesArray[i].height;

                if (this.target.type == shapeTypes.SPEAK_BUBBLE || this.target.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || this.target.type == shapeTypes.SCREAM_BUBBLE || this.target.type == shapeTypes.THOUGHT_BUBBLE) {
                    points[i].cx = this.clonesArray[i].cx;
                    points[i].cy = this.clonesArray[i].cy;

                    if (this.target.cx1) {
                        points[i].cx1 = this.clonesArray[i].cx1;
                        points[i].cy1 = this.clonesArray[i].cy1;
                    }

                    if (this.target.cx2) {
                        points[i].cx2 = this.clonesArray[i].cx2;
                        points[i].cy2 = this.clonesArray[i].cy2;
                    }

                    if (this.target.cx3) {
                        points[i].cx3 = this.clonesArray[i].cx3;
                        points[i].cy3 = this.clonesArray[i].cy3;
                    }

                    if (this.target.cx4) {
                        points[i].cx4 = this.clonesArray[i].cx4;
                        points[i].cy4 = this.clonesArray[i].cy4;
                    }

                    if (this.target.cx5) {
                        points[i].cx5 = this.clonesArray[i].cx5;
                        points[i].cy5 = this.clonesArray[i].cy5;
                    }
                }

                if (this.target.type == shapeTypes.SPEAK_BUBBLE || this.target.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || this.target.type == shapeTypes.SCREAM_BUBBLE || this.target.type == shapeTypes.THOUGHT_BUBBLE || this.target.type == shapeTypes.TEXTBOX || this.target.type == shapeTypes.TEXTBOXSIMPLE) {
                    points[i].fontSize = this.clonesArray[i].fontSize;
                }
            }
        }

        animation.start_opacity = this.target.opacity;
        animation.end_opacity = clone.opacity;

        animation.start_rotation = this.target.rotation;
        animation.end_rotation = clone.rotation;

        animation.rotation_type = animationManager.rotationType;

        if (points.length > 0)
            animation.points = points;

        dispatch(addAnimation(this.target.uuid, animation));
        saveManager.isContentChanged(true);
        audioEditorUtils.addActionToHistory();

        if (!isAnimationMode)
            this.exitAnimationMode();
    },
    enterAnimationMode(shape) {
        this.stopAnimations();

        const dispatch = this.getDispatch();

        dispatch(selectShape(''));
        dispatch(changeInteractionState(shape.uuid, false, false));

        this.isAnimationEditor = true;
        this.target = shape;
        this.initialAnimation = this.target.animation;
        this.clone = undefined;
        this.clonesArray = [];

        let animationPoints = this.getAnimationPoints(shape.animation);

        if (animationPoints.length === 0)
            this.clone = this.duplicateShape(shape, undefined, undefined, true);
        else
        if (animationPoints.length >= 2) {
            this.clone = this.duplicateShape(shape, animationPoints[0], animationPoints[1]);

            for (let i=2; i<animationPoints.length; i++) {
                let isSelected = (i === animationPoints.length - 1);
                this.clonesArray.push(this.duplicateShape(shape, animationPoints[i-1], animationPoints[i], isSelected));
            }
        }

        dispatch(changeContextMode(modeType.ANIMATION_CONTEXT));
    },
    exitAnimationMode() {
        if (!this.isAnimationMode())
            return;

        this.isAnimationEditor = false;
        this.target = undefined;
        this.clone = undefined;
        this.clonesArray = [];

        setTimeout(function() {
            const dispatch = this.getDispatch();
            dispatch(selectShape(''));
            dispatch(changeContextMode(modeType.CONTEXT_NONE));
            dispatch(updateCurrentSlideContent(Math.random()));
        }.bind(this), 15);
    },

    animationTimer: undefined,
    STEP: 15,
    startTime: 0,
    currentTime: 0,
    totalTime: 0,
    pauseSoundStatus: undefined,
    isAnimationTime: false,
    initialAnimation: undefined,
    cloneObject: undefined,
    cloneObjectsArray: [],

    startAnimationInEditMode() {
        this.addAnimation(true);

        this.cloneObject = this.clone;
        this.clone = undefined;

        this.cloneObjectsArray = this.clonesArray;
        this.clonesArray = [];

        const dispatch = this.getDispatch();
        dispatch(selectShape(''));

        setTimeout(function() {
            this.startAnimations(true);
        }.bind(this), 10);
    },
    clearAnimationsInEditMode(isCancel = false) {
        if (this.cloneObject) {
            this.stopAnimations(false);

            if (isCancel) {
                const dispatch = this.getDispatch();
                dispatch(addAnimation(this.target.uuid, this.initialAnimation));
                saveManager.isContentChanged(true);
            }

            this.clone = this.cloneObject;
            this.cloneObject = undefined;
            this.clonesArray = this.cloneObjectsArray;
            this.cloneObjectsArray = [];

            if (this.pauseSoundStatus)
                this.pauseSoundStatus();
        }
    },
    stopAnimationIndEditMode() {
        if (!this.cloneObject)
            return;

        this.stopAnimations(false);

        this.clone = this.cloneObject;
        this.cloneObject = undefined;

        this.clonesArray = this.cloneObjectsArray;
        this.cloneObjectsArray = [];

        if (this.pauseSoundStatus)
            this.pauseSoundStatus();

        const dispatch = this.getDispatch();
        dispatch(selectShape(''));
        dispatch(changeInteractionState(this.target.uuid, true, true));

        setTimeout(function() {
            if (this.target) {
                dispatch(selectShape(this.target.uuid, false, true));
                dispatch(changeInteractionState(this.target.uuid, false, false));
                dispatch(refreshShapePosition(this.target.uuid));
            }
        }.bind(this), 20);
    },
    updateCurrentTime() {
        if (previewCommands.isEditorMode()) {
            setTimeout(function () {
                var model = storeManager.getState().currentSlide.model;
                var shapes = model.content;
                var totalTime = model.time * 1000;
                var animatedShape;

                if (!shapes)
                    return;

                for (var i=0; i<shapes.length; i++) {
                    var shape = shapes[i];

                    if (shape.animation) {
                        animatedShape = shape;
                        break;
                    }
                }

                if (animatedShape) {
                    var animation = animatedShape.animation;
                    var startVal;
                    var endVal;
                    var currentVal;

                    switch (true) {
                        case (animation.start_x != animation.end_x): {
                            startVal = animation.start_x;
                            endVal = animation.end_x;
                            currentVal = animatedShape.x - startVal;
                            break;
                        }

                        case (animation.start_y != animation.end_y): {
                            startVal = animation.start_y;
                            endVal = animation.end_y;
                            currentVal = animatedShape.y - startVal;
                            break;
                        }

                        case (animation.start_width != animation.end_width): {
                            startVal = animation.start_width;
                            endVal = animation.end_width;
                            currentVal = animatedShape.width - startVal;
                            break;
                        }

                        case (animation.start_height != animation.end_height): {
                            startVal = animation.start_height;
                            endVal = animation.end_height;
                            currentVal = animatedShape.height - startVal;
                            break;
                        }

                        case (animation.start_opacity != animation.end_opacity): {
                            startVal = animation.start_opacity;
                            endVal = animation.end_opacity;
                            currentVal = animatedShape.opacity - startVal;
                            break;
                        }

                        case (animation.start_rotation != animation.end_rotation): {
                            startVal = animation.start_rotation;
                            endVal = animation.end_rotation;
                            currentVal = animatedShape.rotation - startVal;
                            break;
                        }

                        case (animation.start_x1 != animation.end_x1): {
                            startVal = animation.start_x1;
                            endVal = animation.end_x1;
                            currentVal = animatedShape.x1 - startVal;
                            break;
                        }

                        case (animation.start_y1 != animation.end_y1): {
                            startVal = animation.start_y1;
                            endVal = animation.end_y1;
                            currentVal = animatedShape.y1 - startVal;
                            break;
                        }

                        case (animation.start_x2 != animation.end_x2): {
                            startVal = animation.start_x2;
                            endVal = animation.end_x2;
                            currentVal = animatedShape.x2 - startVal;
                            break;
                        }

                        case (animation.start_y2 != animation.end_y2): {
                            startVal = animation.start_y2;
                            endVal = animation.end_y2;
                            currentVal = animatedShape.y2 - startVal;
                            break;
                        }
                    }

                    var difference = Math.abs(endVal - startVal);

                    if (difference > 0)
                        this.currentTime = Math.floor((currentVal * totalTime) / difference);
                }
            }.bind(this), 50);
        }
    },
    startAnimations(isPause = false, startOffset = 0, startPlaying = true) {
        if (previewCommands.isEditorMode()) {
            const dispatch = this.getDispatch();
            dispatch(selectShape(''));
        }

        this.stopAnimations(isPause, false);

        if (isPause) {
            if (!this.currentTime)
                this.currentTime = 0;
        } else
            this.currentTime = 0;

        if (startOffset > 0)
            this.currentTime = startOffset;

        var model = storeManager.getState().currentSlide.model;
        this.totalTime = model.time * 1000;
        this.startTime = new Date().getTime();
        this.isAnimationTime = true;

        if (!startPlaying) { // just click on the ruler and change the animation to the current position
            if (startOffset != 0)
                this.animateShapes(true);
        } else
            this.animationTimer = setInterval(this.animateShapes.bind(this), this.STEP);
    },
    exitPreview() {
        this.pauseSoundStatus = undefined;

        setTimeout(function() {
            this.doAnimations(true);
        }.bind(this), 20);
    },
    stopAnimations(isPause = false, updateStartPosition = true) {
        this.totalTime = 0;
        this.isAnimationTime = false;

        if (this.animationTimer)
            clearInterval(this.animationTimer);

        if (!updateStartPosition)
            return;

        if (!isPause) {
            this.currentTime = 0;

            if (!previewCommands.isPlayMode())
                this.doAnimations(true);
        }
    },
    animateShapes(useCurrentPosition = false) {
        if (!useCurrentPosition) {
            var time = new Date().getTime();
            this.currentTime = this.currentTime + (time - this.startTime);
            this.startTime = time;
        }

        if (this.currentTime >= this.totalTime) {
            if (this.isAnimationMode())
                this.stopAnimationIndEditMode();
            else
                this.stopAnimations();

            if (!playController.isAudioEditorMode() && previewCommands.isEditorMode()) {
                if (this.pauseSoundStatus)
                    this.pauseSoundStatus();
            }
        } else
            this.doAnimations();
    },
    isAnimatedSlide() {
        var shapes = storeManager.getState().currentSlide.model.content;

        if (!shapes)
            return false;

        for (var i=0; i<shapes.length; i++) {
            if (shapes[i].animation)
                return true;
        }

        return false;
    },
    isScaleAnimation(shapeModel) {
        if (platformDetection.isIOS() || platformDetection.isEdge() || shapeModel.type == shapeTypes.GROUP || shapeModel.type == shapeTypes.SCREAM_BUBBLE || shapeModel.type == shapeTypes.THOUGHT_BUBBLE)
            return true;
        else
            return false;
    },
    getAnimationPoints(animation) {
        if (!animation)
            return [];

        let points = animation.points ? animation.points : [];
        let animationPoints = [];
        let point;
        let i;

        if (animation.start_x1 && animation.start_x2) {
            point = {};
            point.x1 = animation.start_x1;
            point.y1 = animation.start_y1;
            point.x2 = animation.start_x2;
            point.y2 = animation.start_y2;

            if (animation.start_cx) {
                point.cx = animation.start_cx;
                point.cy = animation.start_cy;
            }

            animationPoints.push(point);

            point = {};
            point.x1 = animation.end_x1;
            point.y1 = animation.end_y1;
            point.x2 = animation.end_x2;
            point.y2 = animation.end_y2;

            if (animation.end_cx) {
                point.cx = animation.end_cx;
                point.cy = animation.end_cy;
            }

            animationPoints.push(point);

            for (i=0; i<points.length; i++) {
                point = {};
                point.x1 = points[i].x1;
                point.y1 = points[i].y1;
                point.x2 = points[i].x2;
                point.y2 = points[i].y2;

                if (points[i].cx) {
                    point.cx = points[i].cx;
                    point.cy = points[i].cy;
                }

                animationPoints.push(point);
            }
        } else {
            point = {};
            point.x = animation.start_x;
            point.y = animation.start_y;
            point.width = animation.start_width;
            point.height = animation.start_height;
            point.cx = animation.start_cx;
            point.cy = animation.start_cy;
            point.cx1 = animation.start_cx1;
            point.cy1 = animation.start_cy1;
            point.cx2 = animation.start_cx2;
            point.cy2 = animation.start_cy2;
            point.cx3 = animation.start_cx3;
            point.cy3 = animation.start_cy3;
            point.cx4 = animation.start_cx4;
            point.cy4 = animation.start_cy4;
            point.cx5 = animation.start_cx5;
            point.cy5 = animation.start_cy5;
            point.fontSize = animation.start_fontSize;
            animationPoints.push(point);

            if (animation.rotation_type === 0) {
                let p = Object.assign({}, point);
                animationPoints.push(p);
            } else {
                point = {};
                point.x = animation.end_x;
                point.y = animation.end_y;
                point.width = animation.end_width;
                point.height = animation.end_height;
                point.cx = animation.end_cx;
                point.cy = animation.end_cy;
                point.cx1 = animation.end_cx1;
                point.cy1 = animation.end_cy1;
                point.cx2 = animation.end_cx2;
                point.cy2 = animation.end_cy2;
                point.cx3 = animation.end_cx3;
                point.cy3 = animation.end_cy3;
                point.cx4 = animation.end_cx4;
                point.cy4 = animation.end_cy4;
                point.cx5 = animation.end_cx5;
                point.cy5 = animation.end_cy5;
                point.fontSize = animation.end_fontSize;
                animationPoints.push(point);
            }

            for (i=0; i<points.length; i++) {
                point = {};
                point.x = points[i].x;
                point.y = points[i].y;
                point.width = points[i].width;
                point.height = points[i].height;
                point.cx = points[i].cx;
                point.cy = points[i].cy;
                point.cx1 = points[i].cx1;
                point.cy1 = points[i].cy1;
                point.cx2 = points[i].cx2;
                point.cy2 = points[i].cy2;
                point.cx3 = points[i].cx3;
                point.cy3 = points[i].cy3;
                point.cx4 = points[i].cx4;
                point.cy4 = points[i].cy4;
                point.cx5 = points[i].cx5;
                point.cy5 = points[i].cy5;
                point.fontSize = points[i].fontSize;

                animationPoints.push(point);
            }
        }

        for (i=0; i<animationPoints.length; i++) {
            point = animationPoints[i];

            if (i === 0) {
                point.opacity = animation.start_opacity;
                point.rotation = animation.start_rotation;
            } else
            if (i === 1) {
                point.opacity = animation.end_opacity;
                point.rotation = animation.end_rotation;
            } else {
                point.opacity = points[i-2].opacity;
                point.rotation = points[i-2].rotation;
            }
        }

        return animationPoints;
    },
    getTargets(shape) {
        let animationPoints = this.getAnimationPoints(shape.animation);
        let targets = {};

        if (animationPoints.length === 2) {
            targets.start = animationPoints[0];
            targets.end = animationPoints[1];
            targets.currentSegment = 0;
            targets.segmentsLength = 1;

            return targets;
        }

        let segments = animationPoints.length - 1;
        let timePerSegment = this.totalTime / segments;

        for (let i=0; i<segments; i++) {
            if (this.currentTime >= i*timePerSegment && this.currentTime < (i+1) * timePerSegment) {
                targets.start = animationPoints[i];
                targets.end = animationPoints[i+1];
                targets.currentSegment = i;
                targets.segmentsLength = segments;

                return targets;
            }
        }

        return undefined;
    },
    doAnimations(setInitialPosition = false) {
        const dispatch = this.getDispatch();
        var shapes = storeManager.getState().currentSlide.model.content;
        var shape;
        var i;
        var animatedShapes = [];
        var animations = [];

        if (!shapes)
            return;

        for (i=0; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.animation) {
                var animation = {};
                let targets = this.getTargets(shape);

                if (!targets && !setInitialPosition)
                    return;

                if (shape.type == shapeTypes.LINE || shape.type == shapeTypes.CURVE) {
                    if (setInitialPosition) {
                        if (shape.animation.start_x1)
                            animation.x1 = shape.animation.start_x1;
                    } else {
                        if (targets.start.x1 && targets.end.x1 && targets.start.x1 !== targets.end.x1)
                            animation.x1 = this.getCurrentValue(targets.start.x1, targets.end.x1, targets.segmentsLength, targets.currentSegment);
                    }

                    if (setInitialPosition) {
                        if (shape.animation.start_y1)
                            animation.y1 = shape.animation.start_y1;
                    } else {
                        if (targets.start.y1 && targets.end.y1 && targets.start.y1 !== targets.end.y1)
                            animation.y1 = this.getCurrentValue(targets.start.y1, targets.end.y1, targets.segmentsLength, targets.currentSegment);
                    }

                    if (setInitialPosition) {
                        if (shape.animation.start_x2)
                            animation.x2 = shape.animation.start_x2;
                    } else {
                        if (targets.start.x2 && targets.end.x2 && targets.start.x2 !== targets.end.x2)
                            animation.x2 = this.getCurrentValue(targets.start.x2, targets.end.x2, targets.segmentsLength, targets.currentSegment);
                    }

                    if (setInitialPosition) {
                        if (shape.animation.start_y2)
                            animation.y2 = shape.animation.start_y2;
                    } else {
                        if (targets.start.y2 && targets.end.y2 && targets.start.y2 !== targets.end.y2)
                            animation.y2 = this.getCurrentValue(targets.start.y2, targets.end.y2, targets.segmentsLength, targets.currentSegment);
                    }

                    if (shape.type == shapeTypes.CURVE) {
                        if (setInitialPosition) {
                            if (shape.animation.start_cx)
                                animation.cx = shape.animation.start_cx;
                        } else {
                            if (targets.start.cx && targets.end.cx && targets.start.cx !== targets.end.cx)
                                animation.cx = this.getCurrentValue(targets.start.cx, targets.end.cx, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cy)
                                animation.cy = shape.animation.start_cy;
                        } else {
                            if (targets.start.cy && targets.end.cy && targets.start.cy !== targets.end.cy)
                                animation.cy = this.getCurrentValue(targets.start.cy, targets.end.cy, targets.segmentsLength, targets.currentSegment);
                        }
                    }
                } else {
                    if (setInitialPosition) {
                        if (shape.animation.start_x)
                            animation.x = shape.animation.start_x;
                    } else {
                        if (shape.animation.rotation_type > 1) {
                            animation.x = this.getCurrentValueForRotation(targets.start.x, targets.start.y, targets.end.x, targets.end.y, true);
                        } else
                        if (targets.start.x && targets.end.x && targets.start.x !== targets.end.x)
                            animation.x = this.getCurrentValue(targets.start.x, targets.end.x, targets.segmentsLength, targets.currentSegment);
                    }

                    if (setInitialPosition) {
                        if (shape.animation.start_y)
                            animation.y = shape.animation.start_y;
                    } else {
                        if (shape.animation.rotation_type > 1) {
                            animation.y = this.getCurrentValueForRotation(targets.start.x, targets.start.y, targets.end.x, targets.end.y, false);
                        } else
                        if (targets.start.y && targets.end.y && targets.start.y !== targets.end.y)
                            animation.y = this.getCurrentValue(targets.start.y, targets.end.y, targets.segmentsLength, targets.currentSegment);
                    }

                    if (setInitialPosition) {
                        if (shape.animation.start_width)
                            animation.width = shape.animation.start_width;
                    } else {
                        if (targets.start.width && targets.end.width && targets.start.width !== targets.end.width)
                            animation.width = this.getCurrentValue(targets.start.width, targets.end.width, targets.segmentsLength, targets.currentSegment);
                    }

                    if (setInitialPosition) {
                        if (shape.animation.start_height)
                            animation.height = shape.animation.start_height;
                    } else {
                        if (targets.start.height && targets.end.height && targets.start.height !== targets.end.height)
                            animation.height = this.getCurrentValue(targets.start.height, targets.end.height, targets.segmentsLength, targets.currentSegment);
                    }

                    if (shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE) {
                        if (setInitialPosition) {
                            if (shape.animation.start_cx)
                                animation.cx = shape.animation.start_cx;
                        } else {
                            if (shape.animation.rotation_type > 1) {
                                animation.cx = this.getCurrentValueForRotation(targets.start.cx, targets.start.cy, targets.end.cx, targets.end.cy, true);
                            } else
                            if (targets.start.cx && targets.end.cx && targets.start.cx !== targets.end.cx)
                                animation.cx = this.getCurrentValue(targets.start.cx, targets.end.cx, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cy)
                                animation.cy = shape.animation.start_cy;
                        } else {
                            if (shape.animation.rotation_type > 1) {
                                animation.cy = this.getCurrentValueForRotation(targets.start.cx, targets.start.cy, targets.end.cx, targets.end.cy, false);
                            } else
                            if (targets.start.cy && targets.end.cy && targets.start.cy !== targets.end.cy)
                                animation.cy = this.getCurrentValue(targets.start.cy, targets.end.cy, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cx1)
                                animation.cx1 = shape.animation.start_cx1;
                        } else {
                            if (shape.animation.rotation_type > 1 && targets.start.cx1 && targets.end.cx1) {
                                animation.cx1 = this.getCurrentValueForRotation(targets.start.cx1, targets.start.cy1, targets.end.cx1, targets.end.cy1, true);
                            } else
                            if (targets.start.cx1 && targets.end.cx1 && targets.start.cx1 !== targets.end.cx1)
                                animation.cx1 = this.getCurrentValue(targets.start.cx1, targets.end.cx1, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cy1)
                                animation.cy1 = shape.animation.start_cy1;
                        } else {
                            if (shape.animation.rotation_type > 1 && targets.start.cy1 && targets.end.cy1) {
                                animation.cy1 = this.getCurrentValueForRotation(targets.start.cx1, targets.start.cy1, targets.end.cx1, targets.end.cy1, false);
                            } else
                            if (targets.start.cy1 && targets.end.cy1 && targets.start.cy1 !== targets.end.cy1)
                                animation.cy1 = this.getCurrentValue(targets.start.cy1, targets.end.cy1, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cx2)
                                animation.cx2 = shape.animation.start_cx2;
                        } else {
                            if (shape.animation.rotation_type > 1 && targets.start.cx2 && targets.end.cx2) {
                                animation.cx2 = this.getCurrentValueForRotation(targets.start.cx2, targets.start.cy2, targets.end.cx2, targets.end.cy2, true);
                            } else
                            if (targets.start.cx2 && targets.end.cx2 && targets.start.cx2 !== targets.end.cx2)
                                animation.cx2 = this.getCurrentValue(targets.start.cx2, targets.end.cx2, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cy2)
                                animation.cy2 = shape.animation.start_cy2;
                        } else {
                            if (shape.animation.rotation_type > 1 && targets.start.cy2 && targets.end.cy2) {
                                animation.cy2 = this.getCurrentValueForRotation(targets.start.cx2, targets.start.cy2, targets.end.cx2, targets.end.cy2, false);
                            } else
                            if (targets.start.cy2 && targets.end.cy2 && targets.start.cy2 !== targets.end.cy2)
                                animation.cy2 = this.getCurrentValue(targets.start.cy2, targets.end.cy2, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cx3)
                                animation.cx3 = shape.animation.start_cx3;
                        } else {
                            if (shape.animation.rotation_type > 1 && targets.start.cx3 && targets.end.cx3) {
                                animation.cx3 = this.getCurrentValueForRotation(targets.start.cx3, targets.start.cy3, targets.end.cx3, targets.end.cy3, true);
                            } else
                            if (targets.start.cx3 && targets.end.cx3 && targets.start.cx3 !== targets.end.cx3)
                                animation.cx3 = this.getCurrentValue(targets.start.cx3, targets.end.cx3, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cy3)
                                animation.cy3 = shape.animation.start_cy3;
                        } else {
                            if (shape.animation.rotation_type > 1 && targets.start.cx3 && targets.end.cx3) {
                                animation.cy3 = this.getCurrentValueForRotation(targets.start.cx3, targets.start.cy3, targets.end.cx3, targets.end.cy3, false);
                            } else
                            if (targets.start.cy3 && targets.end.cy3 && targets.start.cy3 !== targets.end.cy3)
                                animation.cy3 = this.getCurrentValue(targets.start.cy3, targets.end.cy3, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cx4)
                                animation.cx4 = shape.animation.start_cx4;
                        } else {
                            if (shape.animation.rotation_type > 1 && targets.start.cx4 && targets.end.cx4) {
                                animation.cx4 = this.getCurrentValueForRotation(targets.start.cx4, targets.start.cy4, targets.end.cx4, targets.end.cy4, true);
                            } else
                            if (targets.start.cx4 && targets.end.cx4 && targets.start.cx4 !== targets.end.cx4)
                                animation.cx4 = this.getCurrentValue(targets.start.cx4, targets.end.cx4, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cy4)
                                animation.cy4 = shape.animation.start_cy4;
                        } else {
                            if (shape.animation.rotation_type > 1 && targets.start.cy4 && targets.end.cy4) {
                                animation.cy4 = this.getCurrentValueForRotation(targets.start.cx4, targets.start.cy4, targets.end.cx4, targets.end.cy4, false);
                            } else
                            if (targets.start.cy4 && targets.end.cy4 && targets.start.cy4 !== targets.end.cy4)
                                animation.cy4 = this.getCurrentValue(targets.start.cy4, targets.end.cy4, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cx5)
                                animation.cx5 = shape.animation.start_cx5;
                        } else {
                            if (shape.animation.rotation_type > 1 && targets.start.cx5 && targets.end.cx5) {
                                animation.cx5 = this.getCurrentValueForRotation(targets.start.cx5, targets.start.cy5, targets.end.cx5, targets.end.cy5, true);
                            } else
                            if (targets.start.cx5 && targets.end.cx5 && targets.start.cx5 !== targets.end.cx5)
                                animation.cx5 = this.getCurrentValue(targets.start.cx5, targets.end.cx5, targets.segmentsLength, targets.currentSegment);
                        }

                        if (setInitialPosition) {
                            if (shape.animation.start_cy5)
                                animation.cy5 = shape.animation.start_cy5;
                        } else {
                            if (shape.animation.rotation_type > 1 && targets.start.cy5 && targets.end.cy5) {
                                animation.cy5 = this.getCurrentValueForRotation(targets.start.cx5, targets.start.cy5, targets.end.cx5, targets.end.cy5, false);
                            } else
                            if (targets.start.cy5 && targets.end.cy5 && targets.start.cy5 !== targets.end.cy5)
                                animation.cy5 = this.getCurrentValue(targets.start.cy5, targets.end.cy5, targets.segmentsLength, targets.currentSegment);
                        }
                    }

                    if (shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE || shape.type == shapeTypes.TEXTBOX || shape.type == shapeTypes.TEXTBOXSIMPLE) {
                        if (setInitialPosition) {
                            if (shape.animation.start_fontSize)
                                animation.fontSize = shape.animation.start_fontSize;
                        } else {
                            if (targets.start.fontSize && targets.end.fontSize && targets.start.fontSize !== targets.end.fontSize)
                                animation.fontSize = this.getCurrentValue(targets.start.fontSize, targets.end.fontSize, targets.segmentsLength, targets.currentSegment);
                        }
                    }
                }

                if (setInitialPosition) {
                    if (shape.animation.start_opacity >= 0)
                        animation.opacity = shape.animation.start_opacity;
                } else {
                    if (!isNaN(targets.start.opacity) && !isNaN(targets.end.opacity) && targets.start.opacity !== targets.end.opacity)
                        animation.opacity = this.getCurrentValue(targets.start.opacity, targets.end.opacity, targets.segmentsLength, targets.currentSegment);
                }

                if (setInitialPosition) {
                    if (shape.animation.start_rotation >= 0)
                        animation.rotation = shape.animation.start_rotation;
                } else {
                    if (shape.animation.rotation_type === 2) { // rotation around external point but not rotating object
                        if (shape.animation.start_rotation >= 0)
                            animation.rotation = shape.animation.start_rotation;
                    } else
                    if (!isNaN(targets.start.rotation) && !isNaN(targets.end.rotation) && targets.start.rotation !== targets.end.rotation)
                        animation.rotation = this.getCurrentValue(targets.start.rotation, targets.end.rotation, targets.segmentsLength, targets.currentSegment);
                }

                animatedShapes.push(shape.uuid);
                animations[shape.uuid] = animation;
            }
        }

        if (animatedShapes.length > 0)
            dispatch(animate(animatedShapes, animations));

        if (setInitialPosition)
            dispatch(updateCurrentSlide());
    },
    getCurrentValue(startVal, endVal, segmentsLength, currentSegment) {
        let dif = endVal - startVal;
        let totalTime = this.totalTime / segmentsLength;
        let currentTime = this.currentTime - currentSegment * totalTime;
        let position = (currentTime * dif) / totalTime;

        return startVal + position;
    },
    getInitialAngle(x, y, centerX, centerY) {
        let angle = 0;
        let sinAlpha;
        let radius = Math.sqrt((centerX - x) * (centerX - x) + (centerY - y) * (centerY - y)); // distance between 2 points

        switch (true) {
            case (centerY === y && x > centerX) : {
                angle = 0;
                break;
            }
            case (centerX === x && y < centerY) : {
                angle = 90;
                break;
            }
            case (centerY === y && x < centerX) : {
                angle = 180;
                break;
            }
            case (centerX === x && y > centerY) : {
                angle = 270;
                break;
            }

            case (y > centerY && x > centerX) : { // C1
                sinAlpha = Math.abs(y - centerY) / radius;
                angle = Math.asin(sinAlpha);
                angle = angle * 180 / Math.PI; // convert from radians to degrees
                break;
            }
            case (x < centerX && y < centerY) : { // C2
                sinAlpha = Math.abs(y - centerY) / radius;
                angle = Math.asin(sinAlpha);
                angle = 90 + angle * 180 / Math.PI; // convert from radians to degrees
                break;
            }
            case (y > centerY && x < centerX) : { // C3
                sinAlpha = Math.abs(y - centerY) / radius;
                angle = Math.asin(sinAlpha);
                angle = 180 + angle * 180 / Math.PI; // convert from radians to degrees
                break;
            }
            case (x > centerX && y > centerY) : { // C4
                sinAlpha = Math.abs(y - centerY) / radius;
                angle = Math.asin(sinAlpha);
                angle = 270 + angle * 180 / Math.PI; // convert from radians to degrees
                break;
            }
        }

        return angle;
    },
    getCurrentValueForRotation(x, y, centerX, centerY, isX = true) {
        let dif = 360; // degrees
        let stepAngle = (this.currentTime * dif) / this.totalTime;
        let initialAngle = this.getInitialAngle(x, y, centerX, centerY);
        let radius = Math.sqrt((centerX - x) * (centerX - x) + (centerY - y) * (centerY - y)); // distance between 2 points
        let xDif;
        let yDif;
        let newPoint = {};
        let currentAngle = initialAngle - stepAngle;
        let radians;

        if (currentAngle < 0)
            currentAngle = 360 + currentAngle;
        else
            if (currentAngle > 360)
                currentAngle = 360 - currentAngle;

        switch (true) {
            case (currentAngle >= 0 && currentAngle < 90) : { // C1
                radians = Math.PI * currentAngle / 180;
                xDif = radius * Math.cos(radians);
                yDif = radius * Math.sin(radians);
                newPoint.x = centerX + xDif;
                newPoint.y = centerY - yDif;
                break;
            }
            case (currentAngle >= 90 && currentAngle < 180) : { // C2
                currentAngle = 180 - currentAngle;
                radians = Math.PI * currentAngle / 180;
                xDif = radius * Math.cos(radians);
                yDif = radius * Math.sin(radians);
                newPoint.x = centerX - xDif;
                newPoint.y = centerY - yDif;
                break;
            }
            case (currentAngle >= 180 && currentAngle < 270) : { // C3
                currentAngle = currentAngle - 180;
                radians = Math.PI * currentAngle / 180;
                xDif = radius * Math.cos(radians);
                yDif = radius * Math.sin(radians);
                newPoint.x = centerX - xDif;
                newPoint.y = centerY + yDif;
                break;
            }
            case (currentAngle >= 270 && currentAngle < 360) : { // C4
                currentAngle = 360 - currentAngle;
                radians = Math.PI * currentAngle / 180;
                xDif = radius * Math.cos(radians);
                yDif = radius * Math.sin(radians);
                newPoint.x = centerX + xDif;
                newPoint.y = centerY + yDif;
                break;
            }
        }

        if (isNaN(newPoint.x) || isNaN(newPoint.y)) {
            newPoint = {};
            newPoint.x = x;
            newPoint.y = y;
        }

        if (isX)
            return newPoint.x;
        else
            return newPoint.y;
    },


    getLineProperties(x1, y1, x2, y2) {
        var distance = Math.sqrt((x1-x2)*(x1-x2) + (y1-y2)*(y1-y2));
        var centerX = (x1+x2)/2;
        var centerY = (y1+y2)/2;

        var angle = Math.atan2(y1-y2, x1-x2);
        var angleDegrees = (angle * 180) / Math.PI;

        var properties = {};

        properties.width = distance;
        properties.height = 4;
        properties.top = centerY;
        properties.left = centerX - distance / 2;
        properties.rotation = angleDegrees;

        return properties;
    },
    getAllAnimationTargets(includeOriginal = true) {
        let clones= [];

        if (!animationManager.clone)
            return clones;

        if (includeOriginal)
            clones.push(animationManager.target);

        clones.push(animationManager.clone);
        clones = clones.concat(animationManager.clonesArray);

        return clones;
    },
    replaceClone(newShape) {
        if (animationManager.clone && animationManager.clone.uuid === newShape.uuid) {
            animationManager.clone = newShape;
            return;
        }

        let clones = animationManager.clonesArray;

        for (let i=0; i<clones.length; i++) {
            if (clones[i].uuid === newShape.uuid)
                clones[i] = newShape;
        }
    },
    getCloneByUid(uuid) {
        let clones = animationManager.clonesArray;

        for (let i=0; i<clones.length; i++) {
            if (clones[i].uuid === uuid)
                return clones[i];
        }

        return  undefined;
    },
    onAddKeyHandler(e) {
        if (e.keyCode === 13)
            animationManager.onAddClick();
    },
    onAddClick(e) {
        if (e && mouseUtils.rejectMouseEvent(e))
            return;

        let shape;
        const dispatch = animationManager.getDispatch();

        if (animationManager.clonesArray.length > 0)
            shape = animationManager.clonesArray[animationManager.clonesArray.length - 1];
        else
            shape = animationManager.clone;
        dispatch(selectShape(''));

        let duplicatedShape = animationManager.duplicateShape(shape, undefined, undefined, true);
        
        animationManager.clonesArray.push(duplicatedShape);
        dispatch(updateCurrentSlideContent(Math.random()));
        dispatch(refreshShapePosition(duplicatedShape.uuid));
    },
    onDeleteKeyHandler(e) {
        if (e.keyCode === 13)
            animationManager.onDeleteClick();
    },
    onDeleteClick(e) {
        if (e && mouseUtils.rejectMouseEvent(e))
            return;

        animationManager.deleteClones();
    },
    deleteClones(deleteAll = false) {
        const dispatch = animationManager.getDispatch();
        let shapeUuid = '';

        if (animationManager.clonesArray.length > 0) {
            if (deleteAll)
                animationManager.clonesArray = [];
            else {
                animationManager.clonesArray = animationManager.clonesArray.slice(0, -1);

                if (animationManager.clonesArray.length > 0) {
                    shapeUuid = animationManager.clonesArray[animationManager.clonesArray.length - 1].uuid;
                    dispatch(selectShape(shapeUuid));
                } else
                    if (animationManager.clone) {
                        shapeUuid = animationManager.clone.uuid;
                        dispatch(selectShape(shapeUuid));
                    }
            }

            dispatch(updateCurrentSlideContent(Math.random()));
            dispatch(refreshShapePosition(shapeUuid));
        }
    },
    getLine(target, clone, index, length) {
        var centerA = (target.type == shapeTypes.LINE || target.type == shapeTypes.CURVE) ? {x: Math.min(target.x1, target.x2) + Math.abs(target.x1 - target.x2) / 2, y: Math.min(target.y1, target.y2) + Math.abs(target.y1 - target.y2) / 2} : {x: target.x + target.width / 2, y: target.y + target.height / 2};
        var centerB = (clone.type == shapeTypes.LINE || clone.type == shapeTypes.CURVE) ? {x: Math.min(clone.x1, clone.x2) + Math.abs(clone.x1 - clone.x2) / 2, y: Math.min(clone.y1, clone.y2) + Math.abs(clone.y1 - clone.y2) / 2} : {x: clone.x + clone.width / 2, y: clone.y + clone.height / 2};
        var lineProperties = this.getLineProperties(centerA.x - 2, centerA.y - 2, centerB.x - 2, centerB.y - 2);
        var radius = 15;
        let addButtonRadius = platformDetection.isIOS() ? radius * 0.75 : radius * 0.5;
        let letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

        var textStyle = {
            fontSize: 19,
            fontWeight: 'bold',
            color: 'black',
            paddingLeft: 8,
            paddingTop: 5,
            zIndex: 1000
        };
        return (<g>
            <g pointerEvents={'none'}>
                <g transform={`translate(${lineProperties.left} ${lineProperties.top})`}>
                    <g transform={`rotate(${lineProperties.rotation} ${lineProperties.width / 2} ${lineProperties.height / 2})`}>
                        <rect
                            x={0}
                            y={0}
                            width={lineProperties.width}
                            height={lineProperties.height}
                            fill={'#dd5052'}
                        />
                        ;
                    </g>
                </g>

                <circle cx={centerA.x} cy={centerA.y} r={radius} fill={'#dd5052'}/>
                <foreignObject x={centerA.x - radius} y={centerA.y - radius} width={radius * 2} height={radius * 2}>
                    <div style={textStyle}>{letters[index]}</div>
                </foreignObject>

                <circle cx={centerB.x} cy={centerB.y} r={radius} fill={'#dd5052'}/>
                <foreignObject x={centerB.x - radius} y={centerB.y - radius} width={radius * 2} height={radius * 2}>
                    <div style={textStyle}>{letters[index+1]}</div>
                </foreignObject>
            </g>

            {(window.location.href.indexOf('stage') !== -1 || window.location.href.indexOf('local') !== -1) ?
                <g>
                    {index === length - 2 ?
                        <g>
                            <a href='#' onClick={this.onAddClick} onTouchEnd={this.onAddClick} onKeyDown={this.onAddKeyHandler}>
                                <circle cx={centerB.x + radius} cy={centerB.y + radius} r={addButtonRadius}
                                        fill={uiProperties.ROTATE_FILL_INACTIVE} strokeWidth={uiProperties.STROKE}
                                        stroke={uiProperties.ROTATE_STROKE_INACTIVE}/>
                                <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg'}
                                       x={centerB.x + radius - addButtonRadius} y={centerB.y + radius - addButtonRadius} width={2 * addButtonRadius} height={2 * addButtonRadius}
                                       preserveAspectRatio="none" pointerEvents={'none'}/>
                            </a>
                        </g> : null
                    }

                    {index === length - 2 && index > 0 ?
                        <g>
                            <a href='#' onClick={this.onDeleteClick} onTouchEnd={this.onDeleteClick} onKeyDown={this.onDeleteKeyHandler}>
                                <circle cx={centerB.x - radius} cy={centerB.y + radius} r={addButtonRadius} fill={'#ff0000'}
                                        strokeWidth={uiProperties.STROKE} stroke={uiProperties.ROTATE_STROKE_ACTIVE}/>
                                <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/textEditor/minus.svg'}
                                       x={centerB.x - radius - addButtonRadius} y={centerB.y + radius - addButtonRadius} width={2 * addButtonRadius} height={2 * addButtonRadius}
                                       preserveAspectRatio="none" pointerEvents={'none'}/>
                            </a>
                        </g> : null
                    }
                </g>  : null
            }
        </g>);
    }
};

export default animationManager;



/** WEBPACK FOOTER **
 ** ./src/components/utils/AnimationManager.js
 **/